export default "__VITE_PUBLIC_ASSET__35ffa9c4__"